import ActionMenu from "@/v2-backoffice-client/components/actionMenu"

export type FeatureRenameMenuItemProps = {
  /**
   * Per-surface identity: every menu this item appears in is its own
   * clickable element (UI_BackofficeLayers_Rename_MenuItem, ...).
   */
  dataFeatureCode: string
  onSelect(): void
}

/**
 * The "Rename code…" entry of a catalog row's action menu. It only OPENS
 * the dialog — the dialog itself must be mounted OUTSIDE the menu content
 * (menus unmount their content on close, and the dialog has to outlive it).
 */
function FeatureRenameMenuItem(props: FeatureRenameMenuItemProps) {
  const { dataFeatureCode, onSelect } = props

  return (
    <ActionMenu.Item
      iconSrc="pencil"
      data-feature-code={dataFeatureCode}
      onSelect={onSelect}
    >
      Rename code…
    </ActionMenu.Item>
  )
}

export default FeatureRenameMenuItem
